<template>
  <div class="table-wrapper">
    <el-table
      :data="data"
      style="width: 100%"
      :header-cell-style="{
        background: '#99DCFF',
        color: '#FFFFFF',
        height: '84px',
        'font-size': '26px',
        'line-height': '35px',
      }"
      :row-style="{
        background: '#F6F6F6',
        color: '#333333',
        fontSize: '18px',
        height: '60px',
      }"
    >
      <el-table-column
        label="训练日期"
        prop="date"
        align="center"
      ></el-table-column>
      <el-table-column
        label="训练项目"
        prop="content"
        align="center"
      ></el-table-column>
      <el-table-column label="训练时长" prop="duration" align="center">
        <template slot-scope="scope">
          {{ minAndSecond(scope.row.duration) }}
        </template></el-table-column
      >
    </el-table>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

import { minAndSecond } from '@utils'

@Component({})
// 注意修改class名
export default class StasticTable extends Vue {
  @Prop(Array)
  data

  created() {
    console.log(this.data, '测试data')
  }

  // tableList = [
  //   { date: '2022-1-2', time: '2天', type: 'a,bc' },
  //   { date: '2022-1-2', time: '2天', type: 'a,bc' },
  // ]
  minAndSecond = minAndSecond
}
</script>

<style lang="scss">
// 修改变单行高度
// 对ele ui 不需要加scoped
.table-wrapper {
  width: auto;
  height: 1000px;
  padding: 20px 0;
}
.el-table {
  border-radius: 40px;
}
.el-table .cell {
  padding: 0 !important; //这里要提高优先级，不然可能不会被显示。
  height: 30px;
  line-height: 26px !important;
}
</style>
